import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SectionCard from './SectionCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FreeMode, Navigation, Pagination } from 'swiper';

const settings = {
  className: 'slider variable-width',
  dots: false,
  infinite: false,
  centerMode: false,
  initialSlide: 0,
  variableWidth: true,
  arrows: true,
  swipeToSlide: true,
};

function Section({ sectionItems }) {
  return (
    <div className='sectionContainer'>
      <h1>{sectionItems.title}</h1>
      <Swiper spaceBetween={16} slidesPerView={'auto'} freeMode navigation modules={[FreeMode, Pagination, Navigation]} className='swiper-overflow-visible' style={{ marginTop: 16 }}>
        {sectionItems.entities.length > 0 &&
          sectionItems.entities.map((items) => {
            return (
              <SwiperSlide key={items.id}>
                <SectionCard cardItems={items} />
              </SwiperSlide>
            );
          })}
      </Swiper>
    </div>
  );
}

export default Section;
